import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigProjectService {
    private readonly project: {
        config: any;
        env: any;
    };
    
    constructor() {
        const project = window.__project || {};
        this.project = {
            config: project['config'] ?? {},
            env: {
                ...environment,
                ...(project['env'] ?? {})
            }
        };
    }
    
    get<T>(key: string, type: 'config'|'env' = 'config'): T {
        return this.project[type][key];
    }
    
    getAll(): any {
        return this.project;
    }

    getAllConfig(): any {
        return this.project.config;
    }

    getAllEnv(): any {
        return this.project.env;
    }
}